import React from 'react';
import '../styles/App.css';
import { formatDate } from '../utils/helpers';

const CallLogsTable = ({ callLogs, loading }) => {
  return (
    <div className="table-container">
      <table className="call-logs-table">
        <thead>
          <tr className="table-header-row">
            <th className="table-header">#</th>
            <th className="table-header">DATE & TIME</th>
            <th className="table-header">CALLER</th>
            <th className="table-header">RECEIVER</th>
            <th className="table-header">CALLEE COUNTRY</th>
            <th className="table-header">CALL TYPE</th>
            <th className="table-header">CALL STATUS</th>
            <th className="table-header">DURATION (SEC)</th>
            <th className="table-header">COST</th>
            <th className="table-header">HANGUP CAUSE</th>
            <th className="table-header">STATUS CODE</th>
            <th className="table-header">SIP DISPOSITION</th>
            <th className="table-header">START TIME</th>
            <th className="table-header">END TIME</th>
            <th className="table-header">ANSWERED TIME</th>
            <th className="table-header">USER ID</th>
            <th className="table-header">UUID</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="17" className="loading-cell">Loading...</td>
            </tr>
          ) : callLogs.length === 0 ? (
            <tr>
              <td colSpan="17" className="empty-cell">No call logs found</td>
            </tr>
          ) : (
            callLogs.map((log, index) => (
              <tr key={log.id || index} className="table-row">
                <td className="table-cell">{log.id ?? index + 1}</td>

                <td className="table-cell">
                  {log.created_at ? formatDate(log.created_at) : 'N/A'}
                </td>

                <td className="table-cell">{log.caller || 'N/A'}</td>

                <td className="table-cell">
                  <span className="phone-number-link">{log.receiver || 'N/A'}</span>
                </td>

                <td className="table-cell">{log.callee_country_name ? log.callee_country_name.toUpperCase() : 'N/A'}</td>

                <td className="table-cell">
                  <span className={`status-badge status-${log.call_type?.toLowerCase()}`}>
                    {log.call_type || 'N/A'}
                  </span>
                </td>

                <td className="table-cell">
                  <span className={`status-badge status-${log.call_status?.toLowerCase()}`}>
                    {log.call_status || 'N/A'}
                  </span>
                </td>

                <td className="table-cell">{log.duration ?? 0}</td>

                <td className="table-cell">
                  {log.cost != null ? Number(log.cost).toFixed(2) : '0.00'}
                </td>

                <td className="table-cell">{log.hangup_cause || 'N/A'}</td>

                <td className="table-cell">
                  {log.sip_status != null && log.sip_status !== '' ? log.sip_status : 'N/A'}
                </td>

                <td className="table-cell">{log.sip_disposition || 'N/A'}</td>

                <td className="table-cell">
                  {log.start_time ? formatDate(log.start_time) : 'N/A'}
                </td>

                <td className="table-cell">
                  {log.end_time ? formatDate(log.end_time) : 'N/A'}
                </td>

                <td className="table-cell">
                  {log.answered_time ? formatDate(log.answered_time) : 'N/A'}
                </td>

                <td className="table-cell">
                  {log.user_id != null ? log.user_id : 'N/A'}
                </td>

                <td className="table-cell">{log.uuid || 'N/A'}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CallLogsTable;